import { execute } from '@/graphql/execute';
import { touchEphemeralLayersMutation } from '@/queries/layer.query';
import { useEffect } from 'react';

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Periodically pings the server for the given ephemeral layer ids so the sweep
 * job knows the owning session is still active. Skips when the id list is empty.
 */
export const useEphemeralLayerHeartbeat = (layerIds: string[]) => {
  useEffect(() => {
    if (layerIds.length === 0) return;
    const tick = () => {
      execute(touchEphemeralLayersMutation, { layerIds }).catch(() => {});
    };
    // First heartbeat right after mount, then on the interval.
    tick();
    const handle = window.setInterval(tick, HEARTBEAT_INTERVAL_MS);
    return () => window.clearInterval(handle);
    // Stringify so we don't restart the interval on every re-render that produces
    // a new array reference but the same contents.
  }, [layerIds.join(',')]);
};
